import {
  Overlay,
  MinimumStockProductsModalTable,
  ErrorDisplay,
  Loader,
} from "src/components";
import { useCompany } from "src/store/slices/companySlice";
import { useCard } from "src/store/slices/cardsSlice";
import { cardConfig } from "src/utils/constants/CardConfig";
import { isModalDataEmpty, renderTestId } from "src/utils/HelperFunctions";
import { useGetModalQuery } from "src/store/serviceApi";

export interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const CARD_ID = "3943b20c-a7ea-4bc2-b0c9-3e777aff70eb";
const MODAL_ID = cardConfig[CARD_ID].modalId;

const MinimumStockProductsModal: React.FC<Props> = ({}) => {
  const { company } = useCompany();
  const card = useCard(CARD_ID);

  const {
    data: modalData,
    isLoading,
    isFetching,
  } = useGetModalQuery({
    id: card?.modal ?? 0,
    companyId: company?.id ?? "",
  });

  if (!modalData) return null;

  return (
    <Overlay
      {...renderTestId(MODAL_ID)}
      id={MODAL_ID}
      className="md:min-w-[640px] md:max-w-[1000px]"
      title={cardConfig[CARD_ID].title}
      variant="Overlay"
      updatedAt={new Date(modalData.updatedAt as string)}
      icon={cardConfig[CARD_ID].icon}
      size="md"
    >
      {isLoading || isFetching ? (
        <Loader variant={"blue"} />
      ) : isModalDataEmpty(modalData.data) ? (
        <ErrorDisplay />
      ) : (
        <MinimumStockProductsModalTable data={modalData} />
      )}
    </Overlay>
  );
};
export default MinimumStockProductsModal;
